export default __webpack_public_path__ + "static/media/DSCN6835.b5ab1d5e.JPG";